// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"z9-z"};